import { BaseCommandProvider } from "common/app/command-palette/providers/base-provider";
import {
  canAccessEntity,
  getEntityIcons,
} from "common/app/command-palette/providers/entities/functions";
import { EntityModule } from "common/app/command-palette/providers/entities/module";
import {
  Command,
  GetCommandsProps,
  RenderModuleProps,
} from "common/app/command-palette/types";
import { Entity } from "common/entities/types";

export class EntitiesProvider extends BaseCommandProvider {
  isModuleProvider() {
    return true;
  }

  getCommands({ context }: GetCommandsProps): Command[] {
    const entityIcons = getEntityIcons(context);

    return Object.values(context.entities)
      .filter((entity) => canAccessEntity(entity))
      .map((entity) => ({
        id: `entities:${entity.name}`,
        label: entity.localizedName,
        icon: entity.css ?? entityIcons[entity.name] ?? "fa-file-o",
        isModule: true,
        onClick: () =>
          this.setModuleRenderer((props) => this.renderModule(props, entity)),
        category: "entity",
      }));
  }

  renderModule = (props: RenderModuleProps, entity: Entity) => {
    return <EntityModule {...props} entity={entity} />;
  };
}
